
import { Component, Vue, Watch, Prop, } from 'vue-property-decorator'
import InputComponent from '@/components/InputHackmetrix/Index.vue'

@Component({
  components: {
    InputComponent,
  },
})
export default class DivisionFrameworkComponent extends Vue {
  @Prop({ required: true, }) readonly showDialog!: string

  private dialog = false

  @Watch('showDialog')
  show (val: boolean): void {
    if (val) {
      this.dialog = true
    }
  }

  @Watch('dialog')
  dialogClose (): void {
    if (this.dialog === false) {
      this.$emit('close')
    }
  }

  private emitEvent () {
    this.dialog = false
    this.$emit('action')
  }
}
